import React, { useState } from "react";
import "./SignUp.css";
import axios from "axios";
import { getData } from "app/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function Index({ faqpost_signup_en, faqpost_signup_zh }) {
  const [status, setStatus] = useState("Submit");
  const [activeId, setActiveId] = useState();
  const lan = useSelector((state) => state?.settings?.lan ?? "en");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const {
      firstName,
      lastName,
      email,
      company,
      phone,
      interest,
      country,
      message,
    } = e.target.elements;
    let details = {
      "first-name": firstName.value,
      "last-name": lastName.value,
      "your-email": email.value,
      "your-company": company.value,
      "your-phone": phone.value,
      "your-interest": interest.value,
      "your-country": country.value,
      "your-message": message.value,
    };

    const form = new FormData();
    for (const field in details) {
      form.append(field, details[field]);
    }
    axios
      .post(
        `https://wpreact.goopter.com/wp-json/contact-form-7/v1/contact-forms/426/feedback`,
        form,
        { headers: { "content-type": "multipart/form-data" } }
      )
      .then(function (response) {
        console.log(response);
        alert(response.data.message);
        setStatus("Submit");
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <div className="signup-page">
      <div className="page-header">
        <div className="row flex-row-reverse">
          <div className="col-lg-6 col-sm-12 mobile-background">
            <div className="text-wrapper">
              <div className="table-cell">
                <div className="page-header-title">
                  <h2>
                    {getData("signUpData")
                      ? getData("signUpData").header.title
                      : null}
                  </h2>
                </div>
                <div className="text">
                  <p>
                    {getData("signUpData")
                      ? getData("signUpData").header.text
                      : null}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="rqp__form-container">
              <form onSubmit={handleSubmit}>
                <div className="rqp__form-container__inputs">
                  <h2>{getData("signUpData").form.title}</h2>
                  <div className="row">
                    <div className="col-lg-6 col-sm-12 first-name">
                      <input
                        type="text"
                        placeholder={getData("signUpData").form.first_name}
                        id="firstName"
                        name="first-name"
                      // required
                      />
                    </div>
                    <div className="col-lg-6 col-sm-12 last-name">
                      <input
                        type="text"
                        placeholder={getData("signUpData").form.last_name}
                        id="lastName"
                        name="last-name"
                      // required
                      />
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder={getData("signUpData").form.email}
                    id="email"
                    name="your-email"
                  // required
                  />
                  <input
                    type="text"
                    placeholder={getData("signUpData").form.phone}
                    id="phone"
                    name="your-phone"
                  />
                  <input
                    type="text"
                    placeholder={getData("signUpData").form.company_or_business}
                    id="company"
                    name="your-company"
                  />
                  <input
                    type="text"
                    placeholder={getData("signUpData").form.store_address}
                    id="store-address"
                    name="store-address"
                  // required
                  />
                  <select id="interest" name="your-interest">
                    <option value="default" disabled selected>
                      {getData("signUpData").form.im_interested_in}
                    </option>
                    <option value="restaurant">
                      {getData("signUpData").form.restaurant}
                    </option>
                    <option value="retail_store">
                      {getData("signUpData").form.retail_store}
                    </option>
                    <option value="online_ordering">
                      {getData("signUpData").form.online_ordering_solution}
                    </option>
                    <option value="delivery_robots">
                      {getData("signUpData").form.delivery_robots}
                    </option>
                    <option value="restaurant-automation">
                      {getData("signUpData").form.restaurant_automation}
                    </option>
                    <option value="photography_service">
                      {getData("signUpData").form.photography_service}
                    </option>
                    <option value="photography_service">
                      {getData("signUpData").form.merchant_service}
                    </option>
                    <option value="other">
                      {getData("signUpData").form.other}
                    </option>
                  </select>
                  <select
                    // name=""
                    // id=""
                    placeholder="Country"
                    id="country"
                    name="your-country"
                  >
                    <option value="default" disabled selected className="gray">
                      {getData("signUpData").form.country}
                    </option>
                    <option value="canada">
                      {getData("signUpData").form.canada}
                    </option>
                    <option value="not_canada">
                      {getData("signUpData").form.not_canada}
                    </option>
                  </select>
                  <textarea
                    type="text"
                    placeholder={getData("signUpData").form.additional_comments}
                    id="message"
                    name="your-message"
                  />
                  <button
                    id="btnFlexFix"
                    className="custom-btn green-button"
                    type="submit"
                  >
                    {getData("signUpData").form.signup}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="signup-contents">
        <div className="container">
          <section className="why-goopter">
            <div className="title">
              <h2>
                {getData("signUpData")
                  ? getData("signUpData").contents.why_goopter.title
                  : null}
              </h2>
            </div>
            <div className="row">
              {getData("signUpData")
                ? getData("signUpData").contents.why_goopter.contents.map(
                  (item) => (
                    <div className="col-lg-4">
                      <div className="icon-wrapper">
                        <item.icon />
                      </div>
                      <div className="text-wrapper">
                        <p>{item.text}</p>
                      </div>
                    </div>
                  )
                )
                : null}
            </div>
          </section>
          <section className="started">
            <div className="title">
              <h2>
                {getData("signUpData")
                  ? getData("signUpData").contents.how_to.title
                  : null}
              </h2>
            </div>
            <ol>
              {getData("signUpData")
                ? getData("signUpData").contents.how_to.list.map((item) => (
                  <li>{item}</li>
                ))
                : null}
            </ol>
          </section>
          <section className="faq">
            <div className="title">
              <h2>
                {getData("signUpData")
                  ? getData("signUpData").contents.faq.title
                  : null}
              </h2>
            </div>
            {faqpost_signup_en && faqpost_signup_zh
              ? lan === "en"
                ? faqpost_signup_en.map((post) => (
                  <>
                    <ul>
                      <li className="container row mx-auto">
                        <div className="faq col-lg-12">
                          <span className="icon">
                            <FontAwesomeIcon icon={faChevronDown} />
                          </span>
                          <NavDropdown
                            title={post.title.rendered}
                            aria-controls="responsive-navbar-nav"
                            className="navbar-expand-sm"
                            onClick={() => {
                              // setActiveId(item.id)
                            }}
                          >
                            <div className="faq-content">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: post.content.rendered,
                                }}
                              ></div>
                            </div>
                            <hr />
                          </NavDropdown>
                        </div>
                        <hr />
                      </li>
                    </ul>
                  </>
                ))
                : lan === "zh"
                  ? faqpost_signup_zh.map((post) => (
                    <>
                      <ul>
                        <li className="container row mx-auto">
                          <div className="faq col-lg-12">
                            <span className="icon">
                              <FontAwesomeIcon icon={faChevronDown} />
                            </span>
                            <NavDropdown
                              title={post.title.rendered}
                              aria-controls="responsive-navbar-nav"
                              className="navbar-expand-sm"
                              onClick={() => {
                              }}
                            >
                              <div className="faq-content">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: post.content.rendered,
                                  }}
                                ></div>
                              </div>
                              <hr />
                            </NavDropdown>
                          </div>
                          <hr />
                        </li>
                      </ul>
                    </>
                  ))
                  : null
              : null}
          </section>
        </div>
      </div>
    </div>
  );
}
